import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { faqData } from '../data/mock';
import JsonLd from './JsonLd';

const FAQ = ({ city = null }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const citySpecificFAQ = city ? [
    {
      question: `Intervenez-vous à ${city} et ses environs ?`,
      answer: `Oui, j'interviens à ${city} et dans toutes les villes environnantes. Mes services de marabout sérieux sont disponibles 24h/24 pour tous les habitants de la région. La distance n'est pas un problème car mes rituels fonctionnent à distance avec la même efficacité. Que vous soyez au centre-ville de ${city} ou dans les communes voisines, je peux vous aider.`
    },
    ...faqData
  ] : faqData;

  return (
    <section className="py-16 bg-gradient-to-b from-black to-zinc-950">
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": citySpecificFAQ.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      }} />
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent">
              Questions Fréquentes {city ? `sur les Marabouts à ${city}` : ''}
            </h2>
            <p className="text-base md:text-lg text-amber-100/70">
              Tout ce que vous devez savoir avant de me consulter
            </p>
          </div>

          <div className="space-y-4">
            {citySpecificFAQ.map((faq, index) => (
              <div
                key={faq.question}
                className="bg-gradient-to-br from-zinc-900/90 to-black border border-amber-600/30 rounded-xl overflow-hidden transition-all duration-300 hover:border-amber-500/50"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none group"
                >
                  <h3 className="text-base md:text-lg font-semibold text-amber-300 group-hover:text-amber-400 transition-colors pr-4">
                    {faq.question}
                  </h3>
                  {openIndex === index ? (
                    <ChevronUp className="w-6 h-6 text-amber-400 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-6 h-6 text-amber-400 flex-shrink-0" />
                  )}
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-5 animate-fadeIn">
                    <p className="text-sm md:text-base text-amber-100/80 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
